import { motion } from "framer-motion";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_elegant-mobile-first-2/artifacts/4yxsazb1_ChatGPT%20Image%202026.%20ju%CC%81n.%2030.%2016_31_45.png";

export default function Header() {
  return (
    <motion.header
      initial={{ y: -24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-[#030712]/60 border-b border-white/5"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-10 md:px-16 h-20 flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-3 group"
          data-testid="header-logo"
        >
          <img
            src={LOGO_URL}
            alt="WEBCRAFT Logo"
            className="h-12 w-12 sm:h-14 sm:w-14 object-contain rounded-md"
            style={{ filter: "drop-shadow(0 0 24px rgba(37,99,235,0.25))" }}
          />
          <span className="hidden sm:inline-block text-sm tracking-[0.32em] uppercase text-white/80 font-medium font-heading">
            Web<span className="text-blue-400">craft</span>
          </span>
        </a>

        <a
          href="#kapcsolat"
          data-testid="header-contact-link"
          className="text-xs sm:text-sm tracking-[0.2em] uppercase text-white/70 hover:text-white transition-colors duration-300 border-b border-white/0 hover:border-white/40 pb-1"
        >
          Kapcsolat
        </a>
      </div>
    </motion.header>
  );
}
